export default "__VITE_ASSET__99fb96c9__"